import React, { createContext, useContext, useMemo, useState } from 'react';

export const CommissionContext = createContext({});

export function CommissionProvider({ children }) {
  const [isOpenModalDepartment, setIsOpenModalDepartment] = useState(false);
  const [isOpenModalStore, setIsOpenModalStore] = useState(false);
  const [isOpenModalReview, setIsOpenModalReview] = useState(false);

  const value = useMemo(
    () => ({
      isOpenModalDepartment,
      setIsOpenModalDepartment,
      isOpenModalStore,
      setIsOpenModalStore,
      isOpenModalReview,
      setIsOpenModalReview,
    }),
    [isOpenModalDepartment, isOpenModalReview, isOpenModalStore],
  );

  return <CommissionContext.Provider value={value}>{children}</CommissionContext.Provider>;
}

export const useCommissionContext = () => useContext(CommissionContext);
